
const tags = {
	state:{
		tagId:'',
		tagSet:new Array,
		cachedViews:new Array
	},
	mutations:{
		SET_TAGID:(state, id) => {
			state.tagId = id
		},
		SET_TAGSET:(state, info) => {
			let flag = false;
			if (state.tagSet.length > 0){
				for (const item of state.tagSet){
					if (item.path == info.path){ //if (item.code == info.code){
						flag = true
						break;
					}
				}
			}
			if (!flag){
				state.tagSet.push(info);
				sessionStorage.setItem('TAG-SET',JSON.stringify(state.tagSet))
			}
		},
		SET_ALL_TAGSET:(state) => {
			if (sessionStorage.getItem('TAG-SET')){
				state.tagSet = JSON.parse(sessionStorage.getItem('TAG-SET'))
			}
		},
		REMOVE_TAGSET:(state,index)=>{
			state.tagSet.splice(index,1);
			sessionStorage.setItem('TAG-SET',JSON.stringify(state.tagSet))
		},
		ADD_CACHED_VIEW: (state, view) => {
			if (state.cachedViews.includes(view.name)) return
			state.cachedViews.push(view.name)
			sessionStorage.setItem('CACHE-VIEWS',JSON.stringify(state.cachedViews))
		},
		ADD_ALL_CACHED_VIEW: (state) => {
			if (sessionStorage.getItem('CACHE-VIEWS')){
				state.cachedViews = JSON.parse(sessionStorage.getItem('CACHE-VIEWS'))
			}
		},
		DEL_CACHED_VIEW: (state, view) => {
			for (const i of state.cachedViews) {
				if (i === view.name) {
					const index = state.cachedViews.indexOf(i)
					state.cachedViews.splice(index, 1)
					sessionStorage.setItem('CACHE-VIEWS',JSON.stringify(state.cachedViews))
					break
				}
			}
		},
		DEL_ALL_VIEW: (state) => {
			state.tagSet.splice(0,state.tagSet.length)
			state.cachedViews.splice(0,state.cachedViews.length)
		},
	},
	actions:{
		setTagId({commit},id){
			commit('SET_TAGID',id)
		},
		addView({ dispatch }, view) {
			dispatch('setTagInfo', view)
			dispatch('addCachedView', view)
		},
		setTagInfo({commit},view){
			commit('SET_TAGSET',view)
		},
		setAllTagInfo({commit},view){
			commit('SET_ALL_TAGSET',view)
		},
		addCachedView({ commit }, view) {
			commit('ADD_CACHED_VIEW', view)
		},
		addAllCachedView({ commit }, view) {
			commit('ADD_ALL_CACHED_VIEW', view)
		},
		removeView({dispatch},view){
			dispatch('REMOVE_TAGSET', view)
			dispatch('DEL_CACHED_VIEW', view)
		},
		removeTagInfo({commit},view){
			commit('REMOVE_TAGSET',view)                                                                                                                                                      
		},
		removeCacheView({commit},view){
			commit('DEL_CACHED_VIEW',view)   
		},
		removeAllView({commit}){
			commit('DEL_ALL_VIEW')
		}
	}
}
export default tags;


// WEBPACK FOOTER //
// ./src/store/modules/tags.js